import { Box, Text } from "@chakra-ui/react";
import React from "react";
import useSmallScreen from "../useSmallScreen";

export const ControlButtons = ({
  bg,
  color,
  icon,
  total,
  onClick,
  smallCurve,
  ...props
}) => {
  const [smallScreen] = useSmallScreen();
  return (
    <Box
      boxShadow={"md"}
      bg={bg}
      color={color}
      p={!smallScreen ? "10px 15px" : "5px"}
      borderRadius="13px"
      fontSize={20}
      cursor="pointer"
      position={"relative"}
      onClick={onClick}
      {...props}
    >
      {icon}
      {total && (
        <Text
          position={"absolute"}
          fontSize=".5em"
          color="#FF0000"
          right="10px"
          top="5px"
          fontWeight={"700"}
        >
          {total}
        </Text>
      )}
    </Box>
  );
};
